import { render, staticRenderFns } from "./NewRule.vue?vue&type=template&id=4be2f48b&scoped=true"
import script from "./NewRule.vue?vue&type=script&lang=js"
export * from "./NewRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2f48b",
  null
  
)

export default component.exports